import { render, staticRenderFns } from "./Pendientes.vue?vue&type=template&id=6c974008"
import script from "./Pendientes.vue?vue&type=script&lang=js"
export * from "./Pendientes.vue?vue&type=script&lang=js"
import style0 from "./Pendientes.vue?vue&type=style&index=0&id=6c974008&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports